exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".page-title[data-v-5b71ea1b]{color:#3882fd;font-family:\"IBM Plex Serif\",serif;font-size:2.2rem;font-weight:600;font-style:normal;font-stretch:normal;line-height:1.2;letter-spacing:normal;margin-top:0;margin-bottom:1.2rem}", ""]);

